<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id="change_in_hypo"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#ChangeInHypo"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Change in Hypothecation</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="ChangeInHypo">
      <div class="risk row" v-if="false">
         <!--Hypothecation Applicable* starts-->
        <div class="form-group col-lg-5 col-md-5 col-sm-6 p-0">
          <div class="form-group d-flex">
            <p class="mr-5">Hypothecation Applicable</p>
            <input
              value="YES"
              type="radio"
              class="input-radio bgc-radio ml-2"
              name="radiobutton"
              id="yes"
              v-model="changeInHypothecationData.hypothecationApplicable.value"
              disabled
            />
            <label class="custom-control-label labelstyle1" for="yes">
              <span class="self-inspection">Yes</span>
            </label>
            <input
              value="NO"
              type="radio"
              class="input-radio bgc-radio ml-5"
              name="radiobutton"
              id="no"
              v-model="changeInHypothecationData.hypothecationApplicable.value"
              disabled
            />
            <label class="custom-control-label labelstyle1" for="no">
              <span class="self-inspection">No</span>
            </label>
          </div>
        </div>
      </div>
       <!--Hypothecation Applicable* ends-->
      <div class="risk row">
          <!--Hypothecation Type* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInHypothecationData.hypothecationType.visibility && changeInHypothecationData.hypothecationApplicable.value == 'YES'">
          <div class="row form-group">
            <float-label
            label="Hypothecation Type*"
            :fixed="isFloat(changeInHypothecationData.hypothecationType.value)">
            <select
              class="form-control"
              placeholder="Hypothecation Type*"
              @change="onBlurHypothecationTypeInstitute()"
              v-model="changeInHypothecationData.hypothecationType.value"
              v-evolvews="changeInHypothecationData.hypothecationType"
              :class="{ 'bgc-error-field': changeInHypothecationData.hypothecationType.errorText!=='' }"
            >
            <option disabled selected value>Hypothecation Type*</option>
            <option disabled value='' v-if='changeInHypothecationData.hypothecationType.value == ""'>Hypothecation Type*</option>
            <option disabled :value='null' v-if='changeInHypothecationData.hypothecationType.value == null'>Hypothecation Type*</option>
            <option v-for="hypothecationType in domainValues.initMotorDomainLists.hypothecationTypes" :key="hypothecationType.code" :value="hypothecationType.code">{{hypothecationType.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="changeInHypothecationData.hypothecationType.errorText !== ''"
            >{{ changeInHypothecationData.hypothecationType.errorText }}</span>
          </div>
        </div>
        <!--Hypothecation Type* ends-->
          <!--Hypothecation Institute* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInHypothecationData.hypothecationInstitute.visibility && changeInHypothecationData.hypothecationApplicable.value == 'YES'">
          <div class="row form-group">
            <float-label label="Hypothecation Institute*" :fixed="isFloat(changeInHypothecationData.hypothecationInstitute.value)"> 
              <input
                v-model="changeInHypothecationData.hypothecationInstitute.value"
                v-evolvews="changeInHypothecationData.hypothecationInstitute"
                type="text"
                maxlength="30"
                @blur="onBlurHypothecationTypeInstitute()"
                :class="{'bgc-error-field':changeInHypothecationData.hypothecationInstitute.errorText !== '',}"
                class="form-control"
                placeholder="Hypothecation Institute*"
              />
            </float-label>
              <span class="error-text" v-if="changeInHypothecationData.hypothecationInstitute.errorText !== ''">
                  {{changeInHypothecationData.hypothecationInstitute.errorText}}</span>
          </div>
        </div>
        <!--Hypothecation Institute* ends-->
        <!--Remarks* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInHypothecationData.hypothicationRemarks.visibility && changeInHypothecationData.hypothecationApplicable.value == 'YES'">
          <div class="row form-group">
            <float-label label="Remarks" :fixed="isFloat(changeInHypothecationData.hypothicationRemarks.value)"> 
              <input
                v-model="changeInHypothecationData.hypothicationRemarks.value"
                v-evolvews="changeInHypothecationData.hypothicationRemarks"
                type="text"
                maxlength="50"
                :class="{'bgc-error-field':changeInHypothecationData.hypothicationRemarks.errorText !== '',}"
                class="form-control"
                placeholder="Remarks"
              />
            </float-label>
              <span class="error-text" v-if="changeInHypothecationData.hypothicationRemarks.errorText !== ''">
                  {{changeInHypothecationData.hypothicationRemarks.errorText}}</span>
          </div>
        </div>
        <!--Remarks* ends-->
      </div>
    </div>
  </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated, onMounted } from "@vue/composition-api";
export default {
  name: "ChangeInHypothecation",
  props: ["changeInHypothecationData",'domainValues'],
  components: {
    FloatLabel
  },
  setup(props, context) {
    let state = reactive({});
    // onMounted
    onMounted(()=>{
      if(props.changeInHypothecationData.hypothecationApplicable.value == 'NO'){
        context.root.$set(props.changeInHypothecationData.hypothecationType,'stepsMandatory', false);
        context.root.$set(props.changeInHypothecationData.hypothecationType,'skip', true);
        context.root.$set(props.changeInHypothecationData.hypothecationInstitute,'stepsMandatory', false);
        context.root.$set(props.changeInHypothecationData.hypothecationInstitute,'skip', true);
      }
      else{
        context.root.$set(props.changeInHypothecationData.hypothecationType,'stepsMandatory', true);
        delete props.changeInHypothecationData.hypothecationType.skip;
        context.root.$set(props.changeInHypothecationData.hypothecationInstitute,'stepsMandatory', true);
        delete props.changeInHypothecationData.hypothecationInstitute.skip;
      }
      context.parent.calculateSteps();
    });
    function onBlurHypothecationTypeInstitute(){
      if(!props.changeInHypothecationData.hypothecationType.value && props.changeInHypothecationData.hypothecationInstitute.value){
        context.root.$set(props.changeInHypothecationData.hypothecationType,'errorText',props.changeInHypothecationData.hypothecationType.errorTypeMandatoryCheck);
      }else{
        context.root.$set(props.changeInHypothecationData.hypothecationType,'errorText','');
      }
    }
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.changeInHypothecationData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      if(props.changeInHypothecationData.hypothecationApplicable.value == 'YES')
        context.parent.enableCalculatePremiumBtn('changeInHypothecation');
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onBlurHypothecationTypeInstitute
    };
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
.custom-control-label::after {
  cursor: not-allowed;
}
</style>

